'use strict';

let ModalView = require('../../js/components/ModalView'),
  config = require('../../js/config.js'),
  lockedOutModalTemplate = require('./templates/_LockedOutModal.hbs'),
  Analytics = require('../../components/Analytics/Analytics'),
  LockedOutModalView = ModalView.extend({
    template: lockedOutModalTemplate,
    onOpen: function() {
      let data = {
        'event': config.analytics.events.error,
        'category': config.analytics.categories.login,
        'action': config.analytics.actions.loginAttempt,
        'label': config.analytics.labels.userLockedOut
      };
      Analytics.emitNewDataLayerEvent(data);
    }
  });

module.exports = LockedOutModalView;



// WEBPACK FOOTER //
// ./assets/components/Login/LockedOutModal.js